export const FONT_SIZES: string[] = [
  '8pt','10pt','12pt','14pt','18pt','24pt','36pt'
];